import script from "./OTabelaUsuariosInativos.vue?vue&type=script&lang=ts&setup=true"
export * from "./OTabelaUsuariosInativos.vue?vue&type=script&lang=ts&setup=true"

import "./OTabelaUsuariosInativos.vue?vue&type=style&index=0&id=7a13c68c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a13c68c"]])

export default __exports__